// ------------------------------------
// Modo de visualização dos blocos
// ------------------------------------
(function () {
  'use strict';

  $('input[name="catalogo-view"]').on('change', function () {
    const viewMode = $('input[name="catalogo-view"]:checked').val();
    changeCatalogViewMode(viewMode);
  });

  function changeCatalogViewMode(viewMode) {
    localStorage.setItem('catalog-view-mode', viewMode);
    $('body').removeClass('cat-grid cat-list').addClass(viewMode);
  }

  if (localStorage.getItem('catalog-view-mode')) {
    const viewMode = localStorage.getItem('catalog-view-mode');
    $('input[name="catalogo-view"][value="' + viewMode + '"]')
      .prop('checked', true)
      .trigger('change');
  }
})();

// ------------------------------------
// Filtros
// ------------------------------------
(function () {
  'use strict';

  // Variáveis
  const $btnToggle = $('.catalogo-filter-toggle');
  const $filtros = $('.catalogo-filtros');
  const $formFiltro = $('.catalogo-filtros form.pg-card');
  const $sortOrder = $('#cat-order');
  const $filtrosCloseBtn = $('.catalogo-filtros-close');
  const $filtrosBtnSubmit = $('.catalogo-filtros-btn .btn');
  const $btnRemFiltro = $('.btn-rem-filter');

  $filtros.on('click', function (ev) {
    if (ev.target == this) {
      hideFiltros();
    }
  });
  $filtros.on('swipeleft', hideFiltros);
  $filtrosCloseBtn.on('click', hideFiltros);
  $btnToggle.on('click', showFiltros);

  // Ao clicar para remover um filtro
  $btnRemFiltro.on('click', function (ev) {
    ev.preventDefault();
    const filter = $(this).data('filter');
    const filterVal = $(this).data('value');
    let params = window.location.search;
    params = decodeURI(params);
    params = params.replace('?', '').replace('#', '');
    params = params.split('&');
    params = params.filter((pi) => !pi.includes('p='));
    params = params.filter((pi) => pi !== filter + '=' + filterVal);
    const queryParams = '?' + params.join('&');
    const urlFilter = location.pathname + encodeURI(queryParams);
    location.href = urlFilter;
  });

  // Exibe os filtros
  function showFiltros() {
    $filtros.addClass('active');
    $('body').addClass('scroll-disabled');
  }

  // Oculta os filtros
  function hideFiltros() {
    $filtros.removeClass('active');
    $('body').removeClass('scroll-disabled');
  }

  // Range slide input
  const $inputRange = $('.js-range-slider');
  const $inputRangeReal = $('#input-range-real-price');
  const $inputRangeVals = $('.js-range-values');
  let firstUpdate = false;
  if ($inputRange.length > 0) {
    $inputRange.ionRangeSlider({
      skin: 'round',
      type: 'double',
      prefix: 'R$ ',
      step: 10,
      hide_from_to: true,
      hide_min_max: true,
      keyboard: false,
      input_values_separator: '-',
      values_separator: ' a ',
      onStart: function (data) {
        updateRangeValues(data);
      },
      onChange: function (data) {
        updateRangeValues(data);
      },
      onFinish: function (data) {
        if (isRangeChanged(data)) {
          $inputRangeReal.val(data.from + '-' + data.to);
          if (isMedia('xl') || isMedia('lg')) {
            enviaFiltros();
          }
        }
      },
    });
    function updateRangeValues(data) {
      const fromVal = 'R$ ' + formatMoneyBR(data.from);
      const toVal = 'R$ ' + formatMoneyBR(data.to);
      $inputRangeVals.find('.min').text(fromVal);
      $inputRangeVals.find('.max').text(toVal);
      if (!firstUpdate) {
        $inputRange.data('cur-from', data.from);
        $inputRange.data('cur-to', data.to);
        firstUpdate = true;
      }
    }
    function isRangeChanged(data) {
      const curFrom = $inputRange.data('cur-from');
      const curTo = $inputRange.data('cur-to');
      return curFrom !== data.from || curTo !== data.to;
    }
  }

  // Envia filtro
  function enviaFiltros() {
    if (!previewMode) {
      let filtrosInputs = '?';
      let inputsArr = $formFiltro.find('input[name!=range-price]').serializeArray();
      inputsArr = inputsArr.filter((inputI) => inputI.value);
      filtrosInputs += inputsArr
        .map((inputI) => {
          return inputI.name + '=' + inputI.value;
        })
        .join('&');
      const sortOrder = $sortOrder.val();
      const sortSufix = filtrosInputs != '?' ? '&' : '';
      filtrosInputs += sortSufix + 'order=' + sortOrder;
      const urlFiltros = location.pathname + filtrosInputs;
      //console.log(urlFiltros);
      location.href = urlFiltros;
    }
  }

  $formFiltro.on('change', '.form-check input', function () {
    if (isMedia('xl') || isMedia('lg')) {
      enviaFiltros();
    }
  });
  $sortOrder.on('change', function () {
    enviaFiltros();
  });
  $filtrosBtnSubmit.on('click', function (ev) {
    ev.preventDefault();
    enviaFiltros();
  });
})();
